import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { catalogUERBaseCostHistoryStatusCountsGql } from 'pages/Catalogs/CatalogUERBaseCost/catalogUerBaseCostQueries';

import { useEffect, useMemo } from 'react';

interface IUseHistoryCountsProps {
    catalogUniqueId: string | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
}

const requestId = 'catalogUERBaseCostHistoryStatusCounts';

export const useHistoryCounts = ({ catalogUniqueId, startDate, endDate }: IUseHistoryCountsProps) => {
    const variables = useMemo(() => {
        if (catalogUniqueId && startDate && endDate) {
            return {
                catalogUniqueId,
                startDate,
                endDate,
            };
        }

        return undefined;
    }, [catalogUniqueId, endDate, startDate]);

    const [data] = useRequest({
        requestId,
        query: catalogUERBaseCostHistoryStatusCountsGql,
        variables,
        withEffect: !!variables,
    });

    const [resetData] = useResetStoreData({
        requestId,
    });

    useEffect(() => {
        if (!startDate) {
            resetData(undefined);
        }
    }, [endDate, resetData, startDate]);

    const countsObj = useMemo(
        () => ({
            deletedCostsCount: data?.catalogUERBaseCostHistoryStatusCounts?.data?.deletedCostsCount ?? 0,
            updatedCostsCount: data?.catalogUERBaseCostHistoryStatusCounts?.data?.updatedCostsCount ?? 0,
            createdCostsCount: data?.catalogUERBaseCostHistoryStatusCounts?.data?.newCostsCount ?? 0,
        }),
        [
            data?.catalogUERBaseCostHistoryStatusCounts?.data?.deletedCostsCount,
            data?.catalogUERBaseCostHistoryStatusCounts?.data?.newCostsCount,
            data?.catalogUERBaseCostHistoryStatusCounts?.data?.updatedCostsCount,
        ],
    );

    return countsObj;
};
